module.exports = __webpack_public_path__ + "media/icons/info-94927961.png";